// extracted by mini-css-extract-plugin
export default {"container":"Table_container__S2ZeG","table":"Table_table__6sIvw","stickyHeader":"Table_stickyHeader__5lflf","empty":"Table_empty__M39DB"};